import React from "react";
import { getAllBillingMethods } from "../../services/adv";
import { Breadcrumbs } from "../inventory/components/Breadcrumbs";
import { AddItemButton } from "../inventory/components/AddItemButton";
import BasicTable from "../../components/BasicTable";
import { useCookiesContext } from "../../contexts/CookiesContext";
import { useSelector } from "react-redux";
import { financesBreadcrumbs as breadcrumbs, buttonLabel } from "@revbox/localization";
import { cookiesKeyNames } from "@revbox/common-fe";

const colWidth = {
  billing_contact_name: 100,
  billing_company_name: 100,
  ppc_billing_type: 100,
  billing_registered_address_country_id: 100,
  billing_vat_number: 100,
  account_id: 100,
  campaign_id: 100,
  created_at: 100,
};

const hiddenColumns = [];

const rowFields = [
  "id",
  "billing_contact_name",
  "billing_company_name",
  "ppc_billing_type",
  "billing_registered_address_country_id",
  "billing_vat_number",
  "account_id",
  "campaign_id",
  "created_at",
]

const APV_PUBLISHER_ID = 73;

export default function BillingMethods() {
  const { cookiesData, getPathKey } = useCookiesContext();
  const { getLanguageAbbr } = useCookiesContext();
  const language = getLanguageAbbr();

    const title = breadcrumbs[language].billing_methods
    const breadcrumb= breadcrumbs[language].billing_methods
    const new_btn_title= buttonLabel[language].newBillingMethod
    const edit_redirect="/pub/finance/billing/edit"

    const urlParams = new URLSearchParams(window.location.search);
    const advId = urlParams.get("advId");
    const pubId = urlParams.get("pub"); 

    const breadcrumb_redirect = advId ? `/adv/finance/billing?advId=${advId}&pub=${pubId}` : `/pub/finance/billing`;
    const new_btn_redirect = advId ? `/adv/billing/new?advId=${advId}&pub=${pubId}` : `/pub/finance/billing/new`;

    const user = useSelector(state => state.user)
  
    const currentSkin = cookiesData[getPathKey()]?.[cookiesKeyNames.skinMode] === "dark" ? "dark" : "";
    
    return (
      <React.Fragment>
      <div className="main main-app d-flex flex-column p-3 p-lg-4">
        <div className="d-flex align-items-center justify-content-between mb-4">
          <Breadcrumbs breadcrumb={breadcrumb} breadcrumb_redirect={breadcrumb_redirect} title={title} />
          <AddItemButton new_btn_title={new_btn_title} new_btn_redirect={new_btn_redirect} disabled={user.owner_id === APV_PUBLISHER_ID} />
        </div>

        <BasicTable getData={getAllBillingMethods} url={edit_redirect} hiddenColumns={hiddenColumns} colWidth={colWidth} rowFields={rowFields} skin={currentSkin}/>

        
      </div>
    </React.Fragment>
    )
}